import { useEffect, useState } from "react";

interface EmptyStateProps {
  isLoading: boolean;
  isStats?: boolean;
  isDarkMode: boolean;
}

export function EmptyState({ isLoading, isStats = false, isDarkMode }: EmptyStateProps) {
  const [loadingText, setLoadingText] = useState(".");
  const [penguinSrc, setPenguinSrc] = useState("/imgs/fp_penguin_idle.png");

  useEffect(() => {
    if (isLoading) {
      const ellipsisInterval = setInterval(() => {
        setLoadingText((prev) => {
          return prev === "" ? "." : prev === "." ? ".." : prev === ".." ? "..." : "";
        });
      }, 500);

      const penguinInterval = setInterval(() => {
        setPenguinSrc((prev) =>
          prev === "/imgs/fp_penguin_idle.png"
            ? "/imgs/fp_penguin.png"
            : "/imgs/fp_penguin_idle.png",
        );
      }, 500);

      return () => {
        clearInterval(ellipsisInterval);
        clearInterval(penguinInterval);
      };
    }
  }, [isLoading]);

  return (
    <div
      className={`mt-2 flex flex-col items-center justify-center rounded-lg border-2 ${isDarkMode ? "border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-2px_#37b764]" : "border-brown bg-white text-brown [box-shadow:inset_0_-2px_#342e2e]"} w-[22.5rem] p-3`}
    >
      <div className="flex flex-col items-center justify-center">
        <a href={`https://frenpet.xyz/`} target="_blank" rel="noreferrer">
          <img src={penguinSrc} alt="" className="h-32 w-36" />
        </a>
        <h1 className="font-bold">Fren Pet Analytica</h1>
        <div className="ml-1 flex flex-row">
          <img
            src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
            alt=""
            className="mr-[0.7rem] mt-2 h-4 w-4"
          />
          {isLoading ? (
            <h2 className="mt-2 text-sm font-semibold">
              {isStats ? "Loading stats" : "Loading your Fren Pet data"}
              <div className="inline-block min-w-5 pr-1 text-left">{loadingText}</div>
            </h2>
          ) : (
            <h2 className="mt-2 text-sm font-semibold">Your Fren Pet data</h2>
          )}
          <img
            src={isDarkMode ? "/imgs/darkpaw.svg" : "/imgs/paw.svg"}
            alt=""
            className="ml-1 mr-[0.3rem] mt-2 h-4 w-4"
          />
        </div>
      </div>
      {isLoading ? (
        <p className="mt-3 flex flex-row text-center text-sm"></p>
      ) : (
        <p className="mt-3 text-center text-sm">
          To view pets, stats, and balances, enter your wallet address
        </p>
      )}
    </div>
  );
}
